import React, { type ReactNode } from 'react';
import { Reveal } from './Reveal';
type SectionHeadingProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <Reveal className="mx-auto max-w-3xl text-center" data-id="element-192" data-mp="3jznd68yz9vi4">
      <h2 className={`text-[28px] font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-[42px] ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-193" data-mp="3k29l49ps6d0v">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base sm:text-lg ${isDark ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-194" data-mp="glj8vd3lv3qq">{subtitle}</p>}
    </Reveal>;
}